 import React,{Component} from 'react'
import Link from 'react-router'
 import {language} from 'UTIL/common'
export default class ModalHeader extends Component{
     render(){
        return (
            <div className="modal-header">
                <button type="button" className="close"
                        data-dismiss="modal" aria-hidden="true">
                    &times;
                </button>
                <h4 className="modal-title">
                    <strong>{language()[this.props.title]}</strong>
                </h4>
            </div>
        )
     }
}


// WEBPACK FOOTER //
// ./modules/component/modalHeader.js